/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's considered one of the more reliable predictive equations for resting metabolic rate, but it's still a population-based estimate — actual BMR can vary by 10% or more depending on muscle mass, genetics, and health conditions. Use it as a starting point, then adjust based on real-world weight changes over time.`)
};

const es_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se considera una de las ecuaciones predictivas más confiables para la tasa metabólica en reposo, pero sigue siendo una estimación basada en poblaciones — el BMR real puede variar en un 10% o más dependiendo de la masa muscular, genética y condiciones de salud. Úsala como punto de partida, luego ajusta según cambios reales de peso en el tiempo.`)
};

const de_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie gilt als eine der zuverlässigeren Vorhersagegleichungen für den Grundumsatz, aber es ist immer noch eine populationsbasierte Schätzung — der tatsächliche BMR kann je nach Muskelmasse, Genetik und Gesundheitszuständen um 10 % oder mehr variieren. Verwenden Sie sie als Ausgangspunkt, passen Sie sich dann an echte Gewichtsveränderungen über Zeit an.`)
};

const nl_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het wordt beschouwd als één van de betrouwbaardere voorspellende vergelijkingen voor rustmetabolisch tarief, maar het is nog steeds een schatting op basis van populatie — werkelijke BMR kan 10% of meer variëren afhankelijk van spiermassa, genetica en gezondheidsomstandigheden. Gebruik het als uitgangspunt en pas het vervolgens aan op basis van werkelijke gewichtsveranderingen in de loop van de tijd.`)
};

const fr_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle est considérée comme l'une des équations prédictives les plus fiables pour le taux métabolique au repos, mais c'est toujours une estimation basée sur la population — le BMR réel peut varier de 10 % ou plus en fonction de la masse musculaire, de la génétique et des conditions de santé. Utilisez-la comme point de départ, puis ajustez en fonction des changements de poids réels au fil du temps.`)
};

const it_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È considerata una delle equazioni predittive più affidabili per il metabolismo basale, ma è ancora una stima basata sulla popolazione — il BMR effettivo può variare del 10% o più a seconda della massa muscolare, della genetica e delle condizioni di salute. Usala come punto di partenza, quindi regola in base ai cambiamenti di peso reali nel tempo.`)
};

const pt_br2_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É considerada uma das equações preditivas mais confiáveis para taxa metabólica basal, mas ainda é uma estimativa baseada em população — o BMR real pode variar em 10% ou mais dependendo da massa muscular, genética e condições de saúde. Use como ponto de partida e ajuste com base em mudanças de peso no mundo real ao longo do tempo.`)
};

const pt_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É considerada uma das equações preditivas mais fiáveis para a taxa metabólica em repouso, mas ainda é uma estimativa baseada em população — a TMB real pode variar em 10% ou mais dependendo da massa muscular, genética e condições de saúde. Use-a como ponto de partida e depois ajuste com base nas mudanças reais de peso ao longo do tempo.`)
};

const ja_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安静時代謝率を推定するための、より信頼できる予測方程式の1つと見なされていますが、それでも人口ベースの推定値です—実際のBMRは筋肉量、遺伝学、健康状態に応じて10％以上変動する可能性があります。これを出発点として使用してから、時間経過に伴う実際の体重変化に基づいて調整してください。`)
};

const zh_bmr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它被认为是估算静息代谢率较为可靠的公式之一，但仍是基于人群的估算——实际 BMR 可能因肌肉量、遗传因素和健康状况的不同而有 10% 或更多的差异。请将其作为起点，再根据一段时间内实际体重的变化进行调整。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq3_a", locale)
	if (locale === "en") return en_bmr_faq3_a(inputs)
	if (locale === "es") return es_bmr_faq3_a(inputs)
	if (locale === "de") return de_bmr_faq3_a(inputs)
	if (locale === "nl") return nl_bmr_faq3_a(inputs)
	if (locale === "fr") return fr_bmr_faq3_a(inputs)
	if (locale === "it") return it_bmr_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq3_a(inputs)
	if (locale === "pt") return pt_bmr_faq3_a(inputs)
	if (locale === "ja") return ja_bmr_faq3_a(inputs)
	return zh_bmr_faq3_a(inputs)
};